if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.zoomLevel = 1;
        this.controlsReady = false;
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.setupGalleryControls();
        this.showActiveMedia();
      }

      setupGalleryControls() {
        if (this.controlsReady) return;
        this.controlsReady = true;

        this.querySelectorAll('[data-modal-action]').forEach((button) => {
          button.addEventListener('click', () => this.handleGalleryAction(button.dataset.modalAction));
        });
        this.querySelectorAll('[data-modal-media-id]').forEach((button) => {
          button.addEventListener('click', () => this.activateMedia(button.dataset.modalMediaId));
        });
        this.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') this.changeMedia(-1);
          if (event.key === 'ArrowRight') this.changeMedia(1);
        });
      }

      handleGalleryAction(action) {
        if (action === 'previous') this.changeMedia(-1);
        if (action === 'next') this.changeMedia(1);
        if (action === 'zoom-in') this.setZoom(this.zoomLevel + 0.25);
        if (action === 'zoom-out') this.setZoom(this.zoomLevel - 0.25);
        if (action === 'fullscreen') this.toggleFullscreen();
      }

      get mediaItems() {
        return Array.from(this.querySelectorAll('.product-media-modal__content > [data-media-id]'));
      }

      changeMedia(direction) {
        const items = this.mediaItems;
        if (items.length < 2) return;
        const currentIndex = Math.max(0, items.findIndex((item) => item.classList.contains('active')));
        const nextIndex = (currentIndex + direction + items.length) % items.length;
        this.activateMedia(items[nextIndex].dataset.mediaId);
      }

      activateMedia(mediaId) {
        const target = this.mediaItems.find((item) => item.dataset.mediaId === mediaId);
        if (!target) return;

        this.mediaItems.forEach((item) => item.classList.toggle('active', item === target));
        this.querySelectorAll('[data-modal-media-id]').forEach((button) => {
          const isActive = button.dataset.modalMediaId === mediaId;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
        this.setZoom(1);
      }

      setZoom(level) {
        this.zoomLevel = Math.min(2.5, Math.max(1, level));
        const activeMedia = this.querySelector('.product-media-modal__content > [data-media-id].active');
        this.mediaItems.forEach((item) => item.style.removeProperty('transform'));
        if (activeMedia) activeMedia.style.transform = `scale(${this.zoomLevel})`;

        const zoomOut = this.querySelector('[data-modal-action="zoom-out"]');
        const zoomIn = this.querySelector('[data-modal-action="zoom-in"]');
        if (zoomOut) zoomOut.disabled = this.zoomLevel <= 1;
        if (zoomIn) zoomIn.disabled = this.zoomLevel >= 2.5;
      }

      async toggleFullscreen() {
        const dialog = this.querySelector('.product-media-modal__dialog');
        try {
          if (!document.fullscreenElement && dialog?.requestFullscreen) {
            await dialog.requestFullscreen();
          } else if (document.fullscreenElement && document.exitFullscreen) {
            await document.exitFullscreen();
          }
        } catch (error) {
          // Fullscreen can be blocked by the browser; the gallery remains usable.
        }
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        this.activateMedia(activeMedia.dataset.mediaId);

        const container = this.querySelector('[role="document"]');
        container.scrollTop = 0;
        container.scrollLeft = 0;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
